// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d402308eab31d03d3dae","655":"574040544d43249e8cb7"}[chunkId] + ".js";
};